import { useQuery } from '@tanstack/react-query';
import type { SupportedProject } from '../../api/prdispatch';
import { prDispatchApi } from '../../api/prdispatch/client';
import { useWithAccessToken } from '../../auth/use-with-access-token';

export interface UseSupportedProjectsResult {
  projects: SupportedProject[];
  loading: boolean;
  error: string | null;
}

export const useSupportedProjects = (): UseSupportedProjectsResult => {
  const queryFn = useWithAccessToken((config) => prDispatchApi.listSupportedProjects(config));
  const query = useQuery({
    queryKey: ['prdispatch', 'supported-projects'],
    queryFn: async () => (await queryFn()).data,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
  return {
    projects: query.data ?? [],
    loading: query.isPending,
    error: query.error ? (query.error as Error).message : null,
  };
};
